import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SmartEditLauncherService } from '@spartacus/smartedit/root';
import { OccEndpointsService } from '@spartacus/core';

export function smartEditTimestampInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const smartEditLauncherService = inject(SmartEditLauncherService);
  const occEndpoints = inject(OccEndpointsService);

  const isOccUrl = (url: string): boolean => {
    return url.includes(occEndpoints.getBaseUrl());
  };

  if (isOccUrl(req.url) && smartEditLauncherService.isLaunchedInSmartEdit()) {
    req = req.clone({
      setHeaders: { 'HEA-SmartEdit-Timestamp': Date.now().toString() }
    });
  }

  return next(req);
}
